import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import LanguageSelector from './LanguageSelector';
import './TechTheme.css';

const RegulatoryHomePage = () => {
  const { t } = useLanguage();

  const projects = [
    'nomokratia',
    'chatbots',
    'cybersecurity',
    'publicSector',
    'manuscripts'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white relative">
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(59,130,246,0.1),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(168,85,247,0.08),transparent_50%)]"></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-50 bg-black/40 backdrop-blur-md border-b border-white/10 sticky top-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <img 
                src="/assets/PROTOS-AI-AGENCY-logo-transparent.png" 
                alt="PROTOS AI" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                PROTOS AI
              </span>
            </div>

            {/* Language Selector */}
            <LanguageSelector />
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <main className="relative z-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
          {/* Title */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent">
                {t('newHome.title')}
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto mb-8 leading-relaxed">
              {t('newHome.subtitle')}
            </p>

            <div className="inline-flex items-center space-x-3 px-6 py-3 bg-blue-500/10 border border-blue-500/30 rounded-full">
              <span className="text-blue-400 font-medium text-sm md:text-base">
                {t('newHome.regulations')}
              </span>
            </div>
          </div>

          {/* What we deliver */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              <span className="text-gradient bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                {t('newHome.deliverTitle')}
              </span>
            </h2>

            {/* Projects Grid */}
            <div className="grid md:grid-cols-2 gap-6 mb-16">
              {projects.map((project) => (
                <Card 
                  key={project}
                  className="bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 hover:border-blue-500/30 transition-all duration-300"
                >
                  <CardContent className="p-6">
                    <h3 className="text-xl font-bold text-blue-400 mb-3">
                      {t(`newHome.projects.${project}.title`)}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {t(`newHome.projects.${project}.description`)}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* EU Credentials */}
            <Card className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/30">
              <CardContent className="p-8">
                <p className="text-center text-gray-200 leading-relaxed text-base md:text-lg">
                  {t('newHome.credentials')}
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Contact Section */}
          <div className="text-center mt-20">
            <Card className="bg-white/5 backdrop-blur-sm border border-white/10 max-w-2xl mx-auto">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold mb-4 text-white">Contact</h3>
                <div className="space-y-2 text-gray-300">
                  <p><strong>Email:</strong> <a href="mailto:info@ai-agency.gr" className="text-blue-400 hover:text-blue-300">info@ai-agency.gr</a></p>
                  <p><strong>Phone:</strong> +30 210 440 7770</p>
                  <p><strong>Address:</strong> Arxeologiikou Mousiou 17, 54640 Thessaloniki, Greece</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
};

export default RegulatoryHomePage;
